import computeClassName from '../../../../../../../utils/computeClassName';

export default function CCIconChevronDown8x8({ className }) {
  const computedClassName = computeClassName(className, '');
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <g clipPath="url(#CCIconChevronDown8x8_clip0)">
        <path d="M0.5 6L3.989 2.5L7.5 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="CCIconChevronDown8x8_clip0">
          <rect width="8" height="4.5" fill="white" transform="translate(0 2)"/>
        </clipPath>
      </defs>
    </svg>
);
}
// path => stroke="#1B1C1D"
